export const PLAN_SELECTED_WHAT_INCLUDED = '{{PLAN_SELECTED}} - que incluye';
export const PLAN_SELECTED_BUY = 'contrata {{PLAN_SELECTED}}';
export const RIBBON_COMPONENT = 'RIBBON_COMPONENT';
export const PLAN_SELECTION = 'seleccion de plan';
export const NODE_RIBBONS = 'carruseles {{NODE_NAME}}';

//* CONSTANTS LIMITS CHARACTERES

export const CHARACTERS_BUTTON_CONTRATA = 37;
export const CHARACTERS_BUTTON_INCLUDES = 52;
export const CHARACTERS_LABEL_PROMOTION = 54;
export const CHARACTERS_LABEL_TASK = 24;
export const CHARACTERS_LABEL_PERIODICITY = 9;
export const CHARACTERS_LABEL_PRICE = 10;

export const BUTTON_CONTRATA = 'BUTTON_CONTRATA';
export const BUTTON_INCLUDES = 'BUTTON_INCLUDES';
export const LABEL_PROMOTION = 'LABEL_PROMOTION';
export const LABEL_TASK = 'LABEL_TASK';
export const LABEL_PERIODICITY = 'LABEL_PERIODICITY';
export const LABEL_PRICE = 'LABEL_PRICE';



// WEBPACK FOOTER //
// ./src/packages/components/lib/PlanSelector/constants.ts